import React from "react";
import styled from "styled-components";

import { Svg } from "./Svg";

const TitleStyle = styled.div`
    display: flex;
    margin-bottom: 20px;
    text-transform: uppercase;
    font-size: ${props => props.$fontSize};
    color: ${props => props.theme.primaryLight};
    >svg {
        margin-right: 10px;
    }
    >span {
        padding: 3px 0px;
    }
`;

export const Title = React.memo(props => {

    const { value, size, svgIcon } = props;
    const fontSize = size === "medium" ? "22px" : "18px";

    return (
        <TitleStyle $fontSize={fontSize}>
            {svgIcon &&
                <Svg path={svgIcon} size="24" />
            }
            <span>{value}</span>
        </TitleStyle>
    );
});